import { StickerGridTemplateLV4731 } from './qrcode/StickerGridTemplateLV4731';
import { StickerGridTemplate3667 } from './qrcode/StickerGridTemplate3667';
import { StickerGridTemplate3657 } from './qrcode/StickerGridTemplate3657';

export const gridTemplatesOptions = [
  {
    key: '3657',
    text: 'Avery 3657 (40 stickers 48,5 x 25,4 mm)',
    value: StickerGridTemplate3657.getConstructorFunction,
  },
  {
    key: '3667',
    text: 'Avery 3667 (64 stickers 48,5 x 16,9 mm)',
    value: StickerGridTemplate3667.getConstructorFunction,
  },
  {
    key: 'lv4731',
    text: 'Avery LV4731 (189 stickers 25,4 x 10 mm)',
    value: StickerGridTemplateLV4731.getConstructorFunction,
  },
];

export const defaultGridTemplateProvider = StickerGridTemplate3657.getConstructorFunction;
